import { SwiggyHeaders } from "@swiggy-private/portal-swiggy-one-subscription-context";
import { getBridgeSdk } from "./bridgeSdk";
import { mockSwgyHeaders } from "tests/__mock__/home";


let swHeaders: SwiggyHeaders | void;

export const getSwiggyHeaders = async (): Promise<SwiggyHeaders | void> => {
    if (process.env.NODE_ENV === "development") {
        swHeaders = mockSwgyHeaders;
        return mockSwgyHeaders;
    } else {
        swHeaders = await getBridgeSdk()
            .getSwiggyHeadersDataFromClient()
            .catch(() => void 0);
    }

    return swHeaders;
};
